<template>
<!--Main contents-->
<div class="box_center" id="page_x">
  <h2 class="shadow">{{registered ? 'Success!' : 'Register'}}</h2>
  <div id="feedback" v-if="errors.any() || error">
    <p class="error wrong_name error-box" v-if="errors.has('fname')">Please enter your first name</p>
    <p class="error wrong_name error-box" v-if="errors.has('lname')">Please enter your last name</p>
    <p class="error wrong_email error-box" v-if="errors.has('email')">Please enter a valid email</p>
    <p class="error wrong_message error-box" v-if="errors.has('password')">{{errors.first('password')}}</p>
    <p class="error wrong_message error-box" v-if="errors.has('repeatpassword')">Please repeat password</p>
    <p class="error wrong_message error-box" v-if="error">{{error}}</p>
  </div>
  <div class="input">
    <form name="formregister" v-if="!registered">
      <p class="text_form">
        First Name: <br />
        Last Name: <br />
        Email: <br />
        Password: <br />
        Repeat PW:
      </p>
      <input type="text" name="fname" maxlength="25" v-model="user.fname" v-validate="'required'" data-vv-delay="2000" class="contact_form" autofocus/>
      <input type="text" name="lname" maxlength="50" v-model="user.lname" v-validate="'required'" data-vv-delay="2000" class="contact_form"/>
      <input type="text" name="email" maxlength="100" v-model="user.email" v-validate="'required|email'" data-vv-delay="2000" class="contact_form"/>
      <input type="password" name="password" maxlength="30" v-model="user.password" v-validate="'min:8|required|confirmed:repeatpassword'" data-vv-delay="2000" class="contact_form"/>
      <input type="password" id="label_name" name="repeatpassword" maxlength="30" v-model="user.confirmPassword" v-validate="'required'" data-vv-delay="2000" class="contact_form"/>
      <input type="submit" value="Register" name="submitButton" class="button submit" @click.prevent="signup" />
    </form>
    <div v-if="registered">
      You have successfully registered. <a href="/login">Please log in.</a>
    </div>
    <p>Already a member? <router-link :to="{path: '/login'}">Login in.</router-link></p>
  </div>
</div>
</template>
<script>
import AuthRepository from '../data/auth.repository.js'
import Nav from '../components/Nav'
import _ from 'lodash'
export default {
  components: {
    'navigation': Nav
  },
  data () {
    return {
      registered: false,
      error: '',
      user: {
        fname: '',
        lname: '',
        email: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    signup () {
      this.$validator.validateAll().then(() => {
        AuthRepository.register(this.user).then(user => {
          this.registered = true
          this.error = ''
        }).catch(e => {
          if (e.response && e.response.data) {
            let str = ''
            _.forOwn(e.response.data, (value, key) => {
              str += value.join(', ')
            })
            this.error = str
          }
        }).catch(() => {
          this.error = 'An error has occurred'
        })
      })
    }
  },
  metaInfo: {
    title: 'Register'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// Register.vue?08a0bdeb